"use client";

import { useIdleLogout } from "@/hooks/useIdleLogout";

import { StaySignedInDialog } from "./StaySignedInDialog";

/**
 * Wires the inactivity timer to the warning dialog. Mounted once inside the
 * protected layout's `GlobalDataProvider`, so it runs for all protected routes
 * and no public routes (design §5).
 *
 * No render guard is needed here: `useIdleLogout` runs its shared inactivity
 * clock only while the enabled predicate holds (design §10) — the clock binds
 * no events and `isPrompted` stays false when the feature is off, the session
 * is unauthenticated, or we're in the test env without the E2E override. The
 * dialog therefore stays closed and inert in those cases.
 */
export function InactivityController() {
  const {
    isPrompted,
    remainingSeconds,
    totalSeconds,
    staySignedIn,
    signOutNow,
  } = useIdleLogout();

  return (
    <StaySignedInDialog
      open={isPrompted}
      remainingSeconds={remainingSeconds}
      totalSeconds={totalSeconds}
      onStaySignedIn={staySignedIn}
      onSignOutNow={signOutNow}
    />
  );
}
